import { Link, useLocation } from "@tanstack/react-router";
import { SidebarMenuSubButton, SidebarMenuSubItem, useSidebar } from "ui";

import { type SidebarSubItemConfig } from "src/staticData";

interface SidebarSubLinkProps {
  item: SidebarSubItemConfig;
}

function getIsSidebarSubItemActive(
  item: SidebarSubItemConfig,
  pathname: string,
) {
  const match = { pathname: pathname };

  if (item.activeWhen) {
    return item.activeWhen(match);
  }

  return item.href === pathname;
}
export function SidebarSubLink(props: SidebarSubLinkProps) {
  const sidebar = useSidebar();
  const pathname = useLocation({
    select: (loc) => {
      return loc.pathname;
    },
  });
  const isActive = getIsSidebarSubItemActive(props.item, pathname);

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton asChild isActive={isActive}>
        <Link
          to={props.item.href}
          onClick={() => {
            sidebar.setOpenMobile(false);
          }}
        >
          <span>{props.item.text}</span>
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
